import { createFileRoute } from '@tanstack/react-router';

import { sideline } from '@/api/sideline';
import { SidelineMonitorPage } from '@/components/sideline/SidelineMonitorPage';

function Page() {
  return <SidelineMonitorPage api={sideline} sport="soccer" />;
}

export const Route = createFileRoute('/custom/sideline-monitor')({
  component: Page
});
